var r=Object.freeze({leftArrow:"ArrowLeft",rightArrow:"ArrowRight"});export{r as EVENT_CODES};
//# sourceMappingURL=TabSet.constants.js.map
